import CryptLeftPseudoBox from './CryptLeftPseudoBox';
import CryptRightPseudoBox from './CryptRightPseudoBox';

export const LeftPseudo = CryptLeftPseudoBox;
export const RightPseudo = CryptRightPseudoBox;
